class QueryKeys {
	static forWorkspaceMembers( { workspaceID }: { workspaceID: number } ) {
		return [ 'workspaces', workspaceID, 'members' ];
	}

	static forNonMembers( { workspaceID }: { workspaceID: number } ) {
		return [ 'workspaces', workspaceID, 'nonMembers' ];
	}

	static forMemberAddOnPreviews( { workspaceID }: { workspaceID: number } ) {
		return [ 'workspaces', workspaceID, 'members', 'add_on_preview' ];
	}

	static forMemberAddOnPreview( { workspaceID, quantity }: { workspaceID: number, quantity: number } ) {
		return [ 'workspaces', workspaceID, 'members', 'add_on_preview', quantity ];
	}

	static forScimToken( { workspaceID }: { workspaceID: number } ) {
		return [ 'workspaces', workspaceID, 'scim_token' ];
	}
}

export { QueryKeys };
